import Text from '../../../../../../components/atoms/Text/Text';
import { Colors, FontKeys } from '../../../../../../components/style';

export const CaseProductsTableHeaderText = ({ text, own }) => {
  return (
    <Text
      text={text}
      variant={FontKeys.Variant.Caption}
      size={FontKeys.Size._M}
      weight={FontKeys.Weight.Semibold}
      color={own ? Colors.Sharp.White : Colors.Neutral._600}
    />
  );
};
